import { jsx as _jsx } from "react/jsx-runtime";
import { Popable } from "react-native-popable";
import Icon from "../Icon";
const InfoToolTip = ({ content, position, iconColor, }) => {
    return (_jsx(Popable, { content: content, position: position, strictPosition: false, backgroundColor: "transparent", caret: true, style: { backgroundColor: "transparent", overflow: "visible", width: "auto", zIndex: 999999 }, wrapperStyle: { overflow: "visible", zIndex: 999 }, children: _jsx(Icon, { type: "information", size: "xs", color: iconColor }) }));
};
export default InfoToolTip;
